/**
 * Checks if the current value of filterParams contains any filter actions
 * @param {object} filterParams Filter parameters
 * @returns boolean
 */
export function hasParticipantFilterActive(filterParams) {
    return !!(
        filterParams &&
        (filterParams.text ||
            (filterParams.categories && Object.values(filterParams.categories).find(v => v.length)) ||
            filterParams.active ||
            filterParams.contacts ||
            filterParams.favorites ||
            filterParams.connections ||
            filterParams.mutualFavorites ||
            filterParams.query?.AND?.find(cond => cond.OR?.length))
    );
}
